module.exports = __webpack_public_path__ + "static/media/mic.18f4bb82.png";